package com.writerslab

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/**
 * Renders the tooltip bubble inside a tooltip host element. The host must
 * carry the `wl-tip-host` class and `tabindex="0"` so that touch devices can
 * toggle `:focus-within` to show the bubble. Place this composable as the
 * LAST child of the host so the absolute positioning lines up correctly.
 */
@Composable
fun TooltipBubble(text: String) {
    if (text.isBlank()) return
    Span({ classes("wl-tip") }) { Text(text) }
}
